import React from "react";
import { StatusCheckinEnum } from "../../../model/Enums/StatusCheckinEnum";
import { StyledLegendIconContainerModal } from "../../../styles/pages/Schedule/ScheduleStyle";
import LegendItemIcon from "./LegendItemIcon";

const LegendContentIcons = () => {
    return (
        <StyledLegendIconContainerModal>
            <LegendItemIcon
                labels={["Compensado"]}
                statusCheckin={StatusCheckinEnum.Compensado}
            />
            <LegendItemIcon
                labels={[
                    "Ausência",
                    // "Ausência Justificada"
                ]}
                statusCheckin={StatusCheckinEnum.Ausencia}
            />
            <LegendItemIcon
                labels={[
                    "Check-in não realizado",
                    "Pendência de justificativa",
                ]}
                statusCheckin={StatusCheckinEnum.PendenciaJustificativa}
            />
            <LegendItemIcon
                labels={["Abono em análise"]}
                statusCheckin={StatusCheckinEnum.AbonoAnalise}
            />
            <LegendItemIcon
                labels={[
                    "Check-in justificado",
                    "Check-in realizado",
                    "Dispensado",
                ]}
                statusCheckin={StatusCheckinEnum.CheckinRealizado}
            />
            <LegendItemIcon
                labels={["Desabilitado por interjornada"]}
                statusCheckin={StatusCheckinEnum.DesabilitadoInterjornada}
            />
            <LegendItemIcon
                labels={["Abono legal", "Abono Administrativo"]}
                statusCheckin={StatusCheckinEnum.AbonoLegal}
            />
            <LegendItemIcon
                labels={[
                    "Recesso",
                    "Feriado Municipal",
                    "Feriado Nacional",
                    "Férias",
                    "Licença remunerada",
                    "Licença não remunerada",
                ]}
                statusCheckin={StatusCheckinEnum.Recesso}
            />
            <LegendItemIcon
                labels={[
                    "Indeferido pela Coordenação",
                    "Indeferido pela Administração",
                ]}
                statusCheckin={StatusCheckinEnum.IndeferidoPelaAdministracao}
            />
            <LegendItemIcon
                labels={[
                    "Deferido pela Coordenação",
                    "Deferido pela Administração",
                ]}
                statusCheckin={StatusCheckinEnum.DeferidoPelaAdministracao}
            />
        </StyledLegendIconContainerModal>
    );
};

export default LegendContentIcons;
